import { QualificationViewSchema } from '@fsf/types';
import { _ } from '@ngx-translate/core';
import { z } from 'zod';

export type Qualification = z.infer<typeof QualificationViewSchema>;

/** A trainer option as returned by GET /api/defects/responsible-users. */
export interface TrainerOption {
  id: number;
  name: string;
}

export const StoreQualificationSchema = z.object({
  name: z.string().min(1, { message: 'validation.required' }).max(255),
  description: z.string().max(65535).nullable().optional(),
  user_ids: z.array(z.number()).optional(),
});

export type StoreQualificationPayload = z.infer<
  typeof StoreQualificationSchema
>;

export const UpdateQualificationSchema = StoreQualificationSchema.partial();
export type UpdateQualificationPayload = z.infer<
  typeof UpdateQualificationSchema
>;

export const qualificationTranslations = _([
  'controlPoints.qualifications.title',
  'controlPoints.qualifications.add',
  'controlPoints.qualifications.edit',
  'controlPoints.qualifications.empty',
  'controlPoints.qualifications.emptyCta',
  'controlPoints.qualifications.create',
  'controlPoints.qualifications.deleteConfirmHeader',
  'controlPoints.qualifications.deleteConfirmMessage',
  'controlPoints.qualifications.created',
  'controlPoints.qualifications.updated',
  'controlPoints.qualifications.deleted',
  'controlPoints.qualifications.notFound',
  'controlPoints.qualifications.loadError',
  'controlPoints.qualifications.createError',
  'controlPoints.qualifications.updateError',
  'controlPoints.qualifications.deleteError',
  'controlPoints.qualifications.dashboardDescription',
  'controlPoints.qualifications.dashboardButton',
  'controlPoints.qualifications.fields.name',
  'controlPoints.qualifications.fields.description',
  'controlPoints.qualifications.fields.trainers',
  'controlPoints.qualifications.fields.trainersPlaceholder',
  'controlPoints.qualifications.fields.trainersHint',
  'controlPoints.qualifications.trainerCount',
]);
